import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Plan environments for multiple teams`}</p>
    </PageDescription>
    <p>{`While separate development teams can each have a separate `}<Globals name="env" mdxType="Globals" />{`, how many environments does a set of teams need? There are two approaches.`}</p>
    <p><strong parentName="p">{`Environment per team`}</strong>{`: As described in `}<a parentName="p" {...{
        "href": "/dev-guide/arch/environment"
      }}>{`Environment Architecture`}</a>{`, each development team gets its own `}<Globals name="env" mdxType="Globals" />{`. This approach has several consequences:`}</p>
    <ul>
      <li parentName="ul">{`Each team’s environment is built of independent resources that can be managed and even billed separately`}</li>
      <li parentName="ul">{`Each team can customize the size of its environment, its backend services, and its CI/CD tools`}</li>
      <li parentName="ul">{`For teams in different geographies, each team’s environment can be located in the IBM Cloud region closest to the team’s geography`}</li>
      <li parentName="ul">{`If the client paying for the application’s development wants the development environment located in the client’s geography, the environment can be installed in the region in that geography`}</li>
      <li parentName="ul">{`Several small development teams will each require its own environment, which can lead to higher expense for envrionments with low utilization`}</li>
    </ul>
    <p><strong parentName="p">{`Shared environment`}</strong>{`: An alternative approach is for multiple development teams to share a single `}<Globals name="env" mdxType="Globals" />{`. This approach has several consequences:`}</p>
    <ul>
      <li parentName="ul">{`Resources are shared, including their cost and management duties`}</li>
      <li parentName="ul">{`Shared resources tend to be more highly utilized, although resource contention will occur between the teams`}</li>
      <li parentName="ul">{`Teams can more easily coordinate on applications and microservices that must work together in production`}</li>
      <li parentName="ul">{`Teams must share a single set of CI/CD tools and pipeline configurations that can be managed by a single adminstration team`}</li>
      <li parentName="ul">{`Teams share a single `}<em parentName="li">{`test`}</em>{` namespace and `}<em parentName="li">{`staging`}</em>{` namespace, and must coordinate accordingly`}</li>
    </ul>
    <p>{`Teams that do no wish to use the same CI/CD tools or otherwise want to avoid having to coordinate with each other should use separate development environments. Teams that want to economize, share a set of CI/CD tools, and need to coordinate on application development may find a shared environment easier to use.`}</p>
    <p>{`To create a shared environment, first install a single environment. Then create a `}<em parentName="p">{`dev`}</em>{` namespace for each team, such as `}<em parentName="p">{`dev-team1`}</em>{`, `}<em parentName="p">{`dev-team2`}</em>{`, etc. (The original `}<em parentName="p">{`dev`}</em>{` namespace can be renamed for the first team, `}<em parentName="p">{`dev-team1`}</em>{`.) The multiple developer namespaces all share a single `}<em parentName="p">{`tools`}</em>{` namespace and the CI/CD tools installed in it. They all use Argo CD—one of the Developer Tools—to deploy to shared `}<em parentName="p">{`test`}</em>{` and `}<em parentName="p">{`staging`}</em>{` namespaces. Use `}<a parentName="p" {...{
        "href": "/dev-guide/getting-started-day-0"
      }}>{`Kubernetes RBAC`}</a>{` to control which developers can access which dev namespaces.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      